import React, { useEffect } from "react";
import { Polygon } from "@react-google-maps/api";
import { useSelector, useDispatch } from "react-redux";
import { getDeliveryAreas, polygonSelector } from "../../../../../features/senninha/polygonsSlice";

const DeliveryPolygon = ({ map }) => {
    const dispatch = useDispatch();

    const { areas, areasStatus } = useSelector(polygonSelector);

    useEffect(() => {
        if (areasStatus === 'idle') {
            dispatch(getDeliveryAreas());
        }
    }, [dispatch, areasStatus]);

    return (
        <>
            {areas && areas.length > 0 && areas.map((area, idx) => {
                return (
                    <Polygon
                        key={area.id || idx}
                        paths={area.bounds}
                        options={{
                            fillColor: "#6DCDDB",
                            strokeColor: "#27CDDB",
                            fillOpacity: 0.4,
                            strokeWeight: 2,
                        }}
                        map={map}
                    />
                )
            })}
        </>
    );
};

export default DeliveryPolygon;